<template>
    <div class="m15" ref="body" style="page-break-before: always;" v-if="textoProfissao">
        <hr/>
        <h4 class="simulator-title loaded">Seguro de Responsabilidade Civil Profissional</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>
        <div class="row">
            <div class="col l12 s12" v-html="textoProfissao"></div>
        </div>
        <div class="row">
            <div class="col l12 s12">
                A ideia de responsabilidade civil está relacionada à noção de não prejudicar o outro.
                Ela pode ser definida como a obrigação de reparar o dano que uma pessoa causa a
                outra.<br><br>
            </div>
        </div>
        <div class="row">
            <div class="col l12 s12">
                Para entender melhor, imagine quando nos envolvemos em um acidente de carro,
                causando danos a terceiros. Se tivermos um seguro do veículo, a cobertura para danos
                causados à terceiros pode ser acionada imediatamente. Esse é um tipo de seguro de
                Responsabilidade Civil!
            </div>
        </div>
        <div class="row">
            <div class="col l12 s12">
                O Seguro de Responsabilidade Civil Profissional tem por finalidade garantir a
                indenização ao segurado por danos, não intencionais, corporais e/ou materiais
                causados a terceiros na execução de sua atividade profissional.
            </div>
        </div><br>
        <div class="row">
            <div class="col l12 s12">
                Entendemos, em razão da sua profissão, que seja importante a contratação de uma
                apólice de Seguro de Responsabilidade Civil Profissional para a sua segurança e
                tranquilidade financeira frente a imprevistos que possam ocorrer e envolver terceiros.
            </div>
        </div><br>
        <div class="row">
            <div class="col l12 s12">
                A contratação desse seguro proporcionará maior tranquilidade no desempenho das
                suas atividades do dia a dia, protegendo o seu patrimônio pessoal e a sua reputação
                profissional, em caso de reclamações de terceiros, decorrentes de sua prestação de
                serviços profissionais.
            </div>
        </div><br>
        <div class="row">
            <div class="col l12 s12">
                <b>Principais Coberturas:</b>
                <ul>
                    <li style="list-style:inside;text-indent: 40px;">
                        Custos de Defesa
                    </li><br>

                    <li style="list-style:inside;text-indent: 40px;">
                       Perdas Indenizáveis
                    </li><br>

                    <li style="list-style:inside;text-indent: 40px;">
                       Acordos
                    </li><br>

                    <li style="list-style:inside;text-indent: 40px;">
                       Despesas Emergenciais
                    </li>
                </ul>
            </div>
        </div>
        <hr/>
    </div>
</template>

<script>
    import { get } from '@/helpers/api';
    import TextoHelper from "@/helpers/texto-profissao";
    import Saudacao from './Saudacao'
    export default {
        name: 'ResponsabilidadeCivil',

        components: {
            Saudacao
        },

        data () {
            return {
                textoProfissao: TextoHelper.profissao(this.cliente.pessoa.pessoa_profissao),

                titulo: 'Seguro de Responsabilidade Civil Profissional',
            }
        },

        props: {
            cliente: {
                type: Object,
                default: null
            },
        },

        methods: {

            async plot () {
                if (this.textoProfissao) {
                    return `<div class="m15 page_logo" ref="body" id="civil" style="page-break-before: always;">
                            <div class="site"></div>
                            <h4 class="simulator-title loaded">${this.titulo}</h4>
                            ${this.$refs.saudacao.plot()}
                            <table>
                                <tr>
                                    <td style="font-size:18px;" width="100%">${this.textoProfissao}</td>
                                </tr>
                                <tr>
                                    <td width="100%">
                                        <p style="font-size:18px;text-align:justify;">
                                            A ideia de responsabilidade civil está relacionada à noção de não prejudicar o outro.
                                            Ela pode ser definida como a obrigação de reparar o dano que uma pessoa causa a
                                            outra.
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="100%">
                                        <p style="font-size:18px;text-align:justify;">
                                            Para entender melhor, imagine quando nos envolvemos em um acidente de carro,
                                            causando danos a terceiros. Se tivermos um seguro do veículo, a cobertura para danos
                                            causados à terceiros pode ser acionada imediatamente. Esse é um tipo de seguro de
                                            Responsabilidade Civil!
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="100%">
                                        <p style="font-size:18px;text-align:justify;">
                                            O Seguro de Responsabilidade Civil Profissional tem por finalidade garantir a
                                            indenização ao segurado por danos, não intencionais, corporais e/ou materiais
                                            causados a terceiros na execução de sua atividade profissional.
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="100%">
                                        <p style="font-size:18px;text-align:justify;">
                                            Entendemos, em razão da sua profissão, que seja importante a contratação de uma
                                            apólice de Seguro de Responsabilidade Civil Profissional para a sua segurança e
                                            tranquilidade financeira frente a imprevistos que possam ocorrer e envolver terceiros.
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="100%">
                                        <p style="font-size:18px;text-align:justify;">
                                            A contratação desse seguro proporcionará maior tranquilidade no desempenho das
                                            suas atividades do dia a dia, protegendo o seu patrimônio pessoal e a sua reputação
                                            profissional, em caso de reclamações de terceiros, decorrentes de sua prestação de
                                            serviços profissionais.
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="100%">
                                    <b style="font-weight:bold;">Principais Coberturas:</b><br><br>
                                    <ul>
                                            <li style="list-style:inside;font-size:18px;text-indent: 40px;">
                                                Custos de Defesa
                                            </li><br>

                                            <li style="list-style:inside;font-size:18px;text-indent: 40px;">
                                               Perdas Indenizáveis
                                            </li><br>

                                            <li style="list-style:inside;font-size:18px;text-indent: 40px;">
                                                Acordos
                                            </li><br>

                                            <li style="list-style:inside;font-size:18px;text-indent: 40px;">
                                                Despesas Emergenciais
                                            </li><br>
                                        </ul>
                                    </td>
                                </tr>
                            </table>
                            </div>`
                } else {
                    return ''
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../relatorios/Simulador.scss";
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/ResponsabilidadeCivil.vue